import { memo, useEffect, useState } from "react";
import { getDHM } from "@/utils/dhmCalculation";

const CfdCountdownTimer = ({ until, isModalOpen }) => {
  if (isModalOpen) return;

  const currentDate = new Date();
  const futureDate = new Date();
  futureDate.setDate(
    currentDate.getDate() + parseInt(until / (60 * 60 * 24), 10)
  );
  futureDate.setHours(
    currentDate.getHours() + (parseInt(until / (60 * 60), 10) % 24)
  );
  futureDate.setMinutes(
    currentDate.getMinutes() + (parseInt(until / 60, 10) % 60)
  );
  futureDate.setSeconds(currentDate.getSeconds() + (until % 60));
  const [getCurrentTime, setCurrentTime] = useState(getDHM(futureDate));

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentTime(getDHM(futureDate));
    }, 60000);
    return () => clearInterval(intervalId);
  }, [until]);

  return (
    <div className="mt15 align-items-center d-flex">
      <div className="cols mr10">
        <p className="text-thm bold text-center mb0">
          {getCurrentTime?.days || 0}
        </p>
        <p className="text-thm bold text-center mb0">Days</p>
      </div>
      <p className="text-thm bold text-center mb0">:</p>
      <div className="cols ml10 mr10">
        <p className="text-thm bold text-center mb0">
          {getCurrentTime?.hours || 0}
        </p>
        <p className="text-thm bold text-center mb0">Hours</p>
      </div>
      <p className="text-thm bold text-center mb0">:</p>
      <div className="cols ml10">
        <p className="text-thm bold text-center mb0">
          {getCurrentTime?.minutes || 0}
        </p>
        <p className="text-thm bold text-center mb0">Minutes</p>
      </div>
    </div>
  );
};

export default memo(CfdCountdownTimer);
